export const COUNTRIES_WITH_STATE_PROVINCE = ["CA", "US"];
